/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';

/**
 * Model for title generation requests.
 * @export
 * @interface ConversationTitleRequest
 */
export interface ConversationTitleRequest {
    /**
     * The messages to generate a title from
     * @type {Array<Message>}
     * @memberof ConversationTitleRequest
     */
    messages: Array<Message>;
    /**
     * The conversation ID
     * @type {string}
     * @memberof ConversationTitleRequest
     */
    conversationId: string;
}

/**
 * Check if a given object implements the ConversationTitleRequest interface.
 */
export function instanceOfConversationTitleRequest(value: object): value is ConversationTitleRequest {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function ConversationTitleRequestFromJSON(json: any): ConversationTitleRequest {
    return ConversationTitleRequestFromJSONTyped(json, false);
}

export function ConversationTitleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTitleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'conversationId': json['conversation_id'],
    };
}

export function ConversationTitleRequestToJSON(json: any): ConversationTitleRequest {
    return ConversationTitleRequestToJSONTyped(json, false);
}

export function ConversationTitleRequestToJSONTyped(value?: ConversationTitleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(MessageToJSON)),
        'conversation_id': value['conversationId'],
    };
}

